import { ExpandableTable } from "../../../../components/UniversalTable";
import { documentTypeTableColumns } from "../../../../helpers";
import { PaystubItem } from "../../../../types/verified/paystub";
import { useMemo } from "react";
import { DocumentVerificationProvider } from "shared/types";
import { ExpandedTableRow } from "./slices/ExpandedTableRow";
import { createInscribePaystubRows } from "./utils";

export const PaystubTable = ({
  incomeItems,
  provider
}: {
  incomeItems?: PaystubItem[];
  provider: DocumentVerificationProvider;
}) => {
  const rows = useMemo(() => {
    if (provider === DocumentVerificationProvider.Inscribe)
      return createInscribePaystubRows(incomeItems ?? []);

    const flatPaystubs =
      incomeItems?.flatMap((i) =>
        i.data?.document?.income_sources?.flatMap(
          (incSource) => incSource.pay_stubs
        )
      ) ?? [];
    const flatWarnings =
      incomeItems?.flatMap((i) => i.data?.document?.warnings) ?? [];
    return [...flatWarnings, ...flatPaystubs];
  }, [incomeItems, provider]);

  return (
    <ExpandableTable
      cellClassName="p-4 pl-0 text-sm self-center"
      headerRowClassName="text-content-300 font-medium"
      renderExpanded={(row) => (
        <div className="px-6 py-8 bg-background-900">
          <ExpandedTableRow rowData={row} provider={provider} />
        </div>
      )}
      rows={rows}
      columns={documentTypeTableColumns}
    />
  );
};
